import { ForwardedRef, forwardRef, MutableRefObject, useImperativeHandle, useRef } from "react";
import FormControl from "../Form/FormControl";
import Validators from "../Form/Validators";
import LoginHelper from "./LoginHelper";
import { UpdateEvent } from "../GUIEvents";
import { ILoginForm } from "./LoginForm";
import TextInput, { ITextInput } from "../TextInput/TextInput";

export type TSignupFormProps = {
    onSubmit:React.KeyboardEventHandler
}
export interface ISignupForm extends ILoginForm {
    name:string
}
export default forwardRef((props:TSignupFormProps,ref?:ForwardedRef<ISignupForm>) => {
    const refName = useRef<ITextInput|null>(null)
    const refEmail = useRef<ITextInput|null>(null)
    const refPassword = useRef<ITextInput|null>(null)
    const refConfirm = useRef<ITextInput|null>(null)
    const onPassword = (ref:MutableRefObject<ITextInput|null>) => (e:UpdateEvent<string>) => ref.current?.validate(ref.current?.value, false)
    const PasswordMatch = (ref:MutableRefObject<ITextInput|null>) => (val:string) => {
        if (!ref.current) return "Password is required"
        else if (val!=ref.current.value) return "Password must match"
        else return null
    }
    useImperativeHandle(ref, () => ({
        get name() { return refName.current?.value || "" },
        get email(){ return refEmail.current?.value || ""},
        get password(){ return refPassword.current?.value || ""}
    }), [])
    return <>
        <FormControl validators={[Validators.Required("Name")]}>
            <TextInput ref={refName} placeholder="Name" float={true} defaultValue={LoginHelper.get("name")} onUpdate={LoginHelper.onUpdate("name")}/>
        </FormControl>
        <FormControl validators={[Validators.Email()]}>
            <TextInput ref={refEmail} placeholder="E-mail" float={true} defaultValue={LoginHelper.get("email")} onUpdate={LoginHelper.onUpdate("email")}/>
        </FormControl>
        <FormControl validators={[Validators.Required("Password"), PasswordMatch(refConfirm)]}>
            <TextInput ref={refPassword} placeholder="Password" float={true} inputProps={{type:"password"}} onUpdate={onPassword(refConfirm)}/>
        </FormControl>
        <FormControl validators={[Validators.Required("Confirm"), PasswordMatch(refPassword)]}>
            <TextInput ref={refConfirm} placeholder="Confirm" float={true} inputProps={{type:"password"}} onUpdate={onPassword(refPassword)} onSubmit={props.onSubmit}/>
        </FormControl>
    </>
})